import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Store } from '../store';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SpaService {
    constructor(
        private apiService: ApiService,
        private store: Store,
        private http: HttpClient,
    ) { }

    serviceCategories() {
        return this.http.get(environment.apiPath + 'phorest/service-categories', this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    serviceCategory(categoryId) {
        return this.http.get(environment.apiPath + 'phorest/service-categories/' + categoryId, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    staff() {
        return this.http.get(environment.apiPath + 'phorest/staff', this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    freeAppointments(cat) {
        const startTime = new Date(cat.dateSelected.date);
        const endTime = new Date(cat.dateSelected.date);

        const sTime = new Date(startTime.setHours(0, 0, 0, 0)).toJSON();
        const eTime = new Date(endTime.setHours(23, 59)).toJSON();


        const dataToSend = {
            "clientServiceSelections": [
                {
                    "clientId": "",
                    "serviceSelections": [
                        {
                            "serviceId": cat.serviceId
                        }
                    ]
                }
            ],
            "startTime": sTime,
            "endTime": eTime
        }
        return this.http.post(environment.apiPath + 'phorest/appointments/availability', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );

    }

    customerSearch(email) {
        const dataToSend = {
            email
        }
        return this.http.post(environment.apiPath + 'phorest/client/search', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data.data;
            })
        );
    }


    createClient(user) {
        const dataToSend = {
            user
        }
        return this.http.post(environment.apiPath + 'phorest/client', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    createBooking(booking) {
        const dataToSend = {
            booking
        }
        return this.http.post(environment.apiPath + 'phorest/booking', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

    confirmBooking(booking) {
        const dataToSend = {
            booking
        }
        return this.http.post(environment.apiPath + 'phorest/booking/confirm', dataToSend, this.apiService.getHttpOptions()).pipe(
            map((data: any) => {
                return data;
            })
        );
    }

}
